import { createFileRoute } from "@tanstack/react-router";

import { getArticles } from "@/lib/articles";
import { NewsPageContent } from "../../news/index";

export const Route = createFileRoute("/en/news/")({
	loader: async () => {
		const articles = await getArticles("en");
		return { articles };
	},
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=3600, stale-while-revalidate=86400",
	}),
	head: () => ({
		meta: [
			{ title: "News | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Latest news and announcements from Makedonijaturist AD. Stay updated with our activities, renovations, and hospitality updates.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/news",
			},
		],
	}),
	component: EnNewsPage,
});

function EnNewsPage() {
	const { articles } = Route.useLoaderData();
	return <NewsPageContent articles={articles} />;
}
